import { createSelector } from '@reduxjs/toolkit';
import type RootState from 'app-components/utils/redux-store/rootState';
import { domainLogosSelectors } from './domainLogosSlice';
import { DOMAIN_LOGOS_REDUCER_KEY } from './domainLogosTypes';

/**
 * Generic selector to enrich any list of items with a domain logo.
 *
 * @param getLogoKey - Function to extract the logoKey from each item
 */

export { domainLogosSelectors as stdSliceSelectors };
export const getDomainLogosState = (state: RootState) => state[DOMAIN_LOGOS_REDUCER_KEY];

export const getIsLoading = (state: RootState) => getDomainLogosState(state).isLoading;
export const getError = (state: RootState) => getDomainLogosState(state).error;

export function makeSelectItemsWithLogos<T extends object>(getLogoKey: (item: T) => string) {
  return createSelector(
    [(state: RootState) => domainLogosSelectors.selectEntities(state) ?? {}, (_state: RootState, items: T[]) => items],
    (logoEntities, items) =>
      items.map((item) => {
        const logoKey = getLogoKey(item);
        const logo = logoKey ? logoEntities[logoKey] : undefined;
        return {
          ...item,
          logoKey: logo?.logoUrl ?? null,
        };
      }),
  );
}
